export default "__VITE_ASSET__CYBCnI6f__"